<template>
  <!-- // 电子商务 -->
  <div class="electronicCommerce maxWidth">
    <div
      class="electronicCommerce-bannner"
      :style="'background-image:url(' + bannerImg + ')'"
    >
      <div class="electronicCommerce-bannnerBox">
        <span class="edescription">{{ bannerList.alias }}</span>
        <span class="name">{{ bannerList.name }}</span>
        <span class="description">{{ bannerList.description }}</span>
        <button type="button" @click="clickParent">立即咨询</button>
      </div>
    </div>
    <NavAssembly :navList="navList" />
    <!-- 电商类型 -->
    <div class="systemType" id="electricityType">
      <div class="systemType-top">
        <span
          >{{ typeList.name }}<img src="../../assets/bigTy.png" alt=""
        /></span>
      </div>
      <div class="systemType-main">
        <div class="systemType-pic">
          <img :src="typeList.img" alt="" />
        </div>
        <div class="systemType-mainTop">
          <div class="systemType-mainTopLeft">
            <div class="mainTopLeftBox">
              <span>{{ typeList.description }}</span>
              <div class="">
                <span>{{ typeList.keywords }}</span>
              </div>
            </div>
            <p>{{ typeList.details }}</p>
          </div>
          <div class="systemType-mainTopRight">
            <button type="button" @click="clickParent">立即咨询</button>
          </div>
        </div>
        <div class="systemType-mainList">
          <div
            class="systemType-mainListBox"
            v-for="(item, index) in typeList.lists"
            :key="index"
          >
            <span>{{ item.name }}</span>
            <div class="">
              <span>{{ item.keywords }}</span>
            </div>
            <p :title="item.description">{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="productAdvantages" id="productSuperiority">
      <div class="productAdvantagesBox">
        <div class="productAdvantages-top">
          <img src="../../assets/bigTy.png" alt="" />
          <span>{{ productAdvantagesList.name }}</span>
          <p>{{ productAdvantagesList.description }}</p>
        </div>
        <div
          class="productAdvantages-box"
          v-for="(item, index) in productAdvantagesList.lists"
          :key="index"
        >
          <span class="zimu">{{ item.max_letter }}</span>
          <span class="title">{{ item.alias }}</span
          ><span class="name">{{ item.name }}</span
          ><span class="text">{{ item.description }}</span>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="businessManagement" id="applicationScenarios">
      <div class="businessManagement-top">
        <img src="../../assets/bigTy1.png" alt="" />
        <span>{{ businessManagementList.name }}</span>
        <p>{{ businessManagementList.description }}</p>
      </div>
      <div class="businessManagement-main">
        <div
          class="businessManagement-mainBox"
          v-for="(item, index) in businessManagementList.lists"
          :key="index"
        >
          <div class="businessManagement-number">
            <img :src="item.num_img" alt="" />
          </div>
          <img :src="item.icon" alt="" />
          <span>{{ item.name }}</span>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>
    <!-- 特色功能 -->
    <div class="coreProducts" id="specialFunction">
      <div class="coreProducts-top">
        <img src="../../assets/bigTy.png" alt="" />
        <span>{{ coreProductsList.name }}</span>
      </div>
      <div class="coreProducts-mian">
        <div class="coreProducts-mianLeft">
          <div
            class="coreProducts-mianLeftBox"
            v-for="(item, index) in coreProductsList.lists"
            :key="index"
            :class="{ titleActive: titleShow == index }"
            @click="titleCilck(index)"
          >
            <span>{{ item.name }}</span>
            <img src="../../assets/jiantou1.png" alt="" />
          </div>
        </div>
        <div class="coreProducts-mianRight">
          <div
            class=""
            v-for="(item, index) in coreProductsList.lists"
            :key="index"
          >
            <div class="coreProducts-mianRightBox" v-if="titleShow == index">
              <div class="coreProducts-mianRightBoxLeft">
                <div class="mianRightBoxLeft-top">
                  <span>{{ item.name }}</span>
                  <p>
                    {{ item.description }}
                  </p>
                </div>
                <div class="mianRightBoxLeft-bottom">
                  <span>核心功能:</span>
                  <div class="mianRightBoxLeft-bottomBox">
                    <div
                      class="mianRightBoxLeft-bottomBoxItem"
                      v-for="(itemText, indexText) in item.list"
                      :key="indexText"
                    >
                      <div class="bottomBoxItem-dain"></div>
                      <span>{{ itemText }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="coreProducts-mianRightBoxRight">
                <img :src="item.img" alt="" />
                <button type="button" @click="clickParent">立即咨询</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ChooseUs :chooseUsList="chooseUsList" />
    <CommonProblem :commonProblemList="commonProblemList" />
    <DeliveryList :deliveryList="deliveryList" />
    <DevelopmentProcess :developmentProcessList="developmentProcessList" />
    <ZXDialog ref="mychild" />
  </div>
</template>

<script>
import NavAssembly from "../../components/NavAssembly.vue";
import ChooseUs from "../../components/ChooseUs.vue";
import CommonProblem from "../../components/CommonProblem.vue";
import DeliveryList from "../../components/DeliveryList.vue";
import DevelopmentProcess from "../../components/DevelopmentProcess.vue";
import ZXDialog from "../../components/ZXDialog";
export default {
  name: "electronicCommerce",
  components: {
    NavAssembly,
    ChooseUs,
    CommonProblem,
    DeliveryList,
    DevelopmentProcess,
    ZXDialog
  },
  metaInfo() {
    //设置浏览器标签页标题
    return {
      meta: [
        {
          name: "description",
          content: this.description
        }
      ]
    };
  },
  data() {
    return {
      description: "",
      titleShow: 0,
      bannerList: {},
      productAdvantagesList: {},
      businessManagementList: {},
      coreProductsList: {},
      commonProblemList: {},
      chooseUsList: {},
      deliveryList: {},
      developmentProcessList: {},
      navList: [],
      typeList: {},
      bannerImg: ""
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios.get("index/common/getElectronicCommerce").then(res => {
        // console.log(res);
        if (res.status == 200) {
          this.description = res.data.data.description;
          this.bannerList = res.data.data["01"];
          this.bannerImg = res.data.data["01"].banner[0].pic;
          this.navList = res.data.data["02"];
          this.typeList = res.data.data["03"];
          this.productAdvantagesList = res.data.data["04"];
          this.businessManagementList = res.data.data["05"];
          this.coreProductsList = res.data.data["06"];
          this.chooseUsList = res.data.data["07"];
          this.commonProblemList = res.data.data["08"];
          this.deliveryList = res.data.data["09"];
          this.developmentProcessList = res.data.data["010"];
        }
      });
    },
    titleCilck(index) {
      this.titleShow = index;
    },
    clickParent() {
      this.$refs.mychild.parentHandleclick();
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.electronicCommerce {
  width: 1920px;
  margin: 0 auto;
  margin-top: 70px;
}
.electronicCommerce-bannner {
  height: 737px;
  background-repeat: no-repeat;
  /* background-size: 100%; */
  position: relative;
}
.electronicCommerce-bannnerBox {
  position: absolute;
  top: 149px;
  left: 311px;
  display: flex;
  flex-direction: column;
}
.electronicCommerce-bannnerBox .edescription {
  font-size: 66px;
  font-family: DIN BlackAlternate;
  font-weight: 600;
  color: rgba(69, 70, 71, 0.3);
  line-height: 76px;
  display: block;
  margin-bottom: 74px;
}
.electronicCommerce-bannnerBox .name {
  font-size: 50px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  display: block;
  margin-bottom: 21px;
}
.electronicCommerce-bannnerBox .description {
  width: 518px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  line-height: 28px;
  display: block;
  margin-bottom: 100px;
}
.electronicCommerce-bannnerBox button {
  cursor: pointer;
  width: 210px;
  height: 54px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  border-radius: 6px 0px 6px 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
/* 电商 */
.systemType {
  position: relative;
  margin-top: 72px;
}
.systemType-top {
  text-align: center;
  margin-bottom: 59px;
}
.systemType-top span {
  position: relative;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.systemType-top span img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -7px;
  left: -11%;
}
.systemType-main {
  height: 550px;
  background: #f6fafb;
  border: 1px solid #ffffff;
  padding-top: 37px;
  position: relative;
}
.systemType-pic {
  position: absolute;
  top: 61px;
  left: 31px;
}
.systemType-pic img {
  display: block;
  width: 533px;
  height: 522px;
}
.systemType-mainTop {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  /* text-align: center; */
  align-items: center;
  margin-bottom: 39px;
}
.systemType-mainTopLeft {
  display: flex;
  flex-direction: column;
}

.systemType-mainTopLeft > p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #595959;
}
.mainTopLeftBox {
  display: flex;
  align-items: center;
  margin-bottom: 17px;
}
.mainTopLeftBox > span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #00000c;
  margin-right: 15px;
}
.mainTopLeftBox > div {
  width: 250px;
  height: 22px;
  background: rgba(255, 66, 66, 0.1);
  border: 1px solid #ff4242;
  border-radius: 6px 0px 6px 0px;
  line-height: 17px;
  text-align: center;
}
.mainTopLeftBox > div span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ff4242;
}
.systemType-mainTopRight button {
  width: 100px;
  height: 34px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.systemType-mainList {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.systemType-mainListBox {
  width: 305px;
  height: 174px;
  background: #ffffff;
  border: 1px solid #e5e9ea;
  padding: 27px 21px 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  position: relative;
  z-index: 998;
}
.systemType-mainListBox:nth-child(4n) {
  margin-right: 0;
}
.systemType-mainListBox > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.systemType-mainListBox > div {
  width: fit-content;
  white-space: nowrap;
  padding: 0 5px;
  height: 20px;
  background: rgba(255, 66, 66, 0.1);
  text-align: center;
  line-height: 18px;
  margin-top: 13px;
  margin-bottom: 26px;
}
.systemType-mainListBox > div > span {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ff4242;
}
.systemType-mainListBox > p {
  width: 261px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 24px;
  margin-bottom: 30px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.systemType-mainListBox > img {
  display: block;
  height: 26px;
}
/* 产品优势 */
.productAdvantages {
  width: 1280px;
  height: 358px;
  margin: 0 auto;
  padding-top: 88px;
  display: flex;
  flex-direction: column;
  margin-bottom: 169px;
}
.productAdvantagesBox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 124px;
}
.productAdvantagesBox:last-child {
  /* margin-bottom: 0; */
}
.productAdvantages-top {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-right: 220px;
}
.productAdvantages-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -14px;
  left: -14px;
}
.productAdvantages-top span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 25px;
}
.productAdvantages-top p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
}
.productAdvantages-box {
  width: 278px;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-right: 220px;
  margin-bottom: 163px;
}
.productAdvantages-box:nth-child(3) {
  margin-right: 0;
}
.productAdvantages-box:nth-child(4) {
  /* margin-right: 309px; */
}
.productAdvantages-box:last-child {
  margin-right: 0;
}
.productAdvantages-box:first-child {
  /* margin-right: 100px; */
}
.productAdvantages-box .zimu {
  font-size: 110px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #df3a3a;
  line-height: 26px;
  opacity: 0.06;
  position: absolute;
  left: -33px;
  top: -5px;
}
.productAdvantages-box .title {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #df3a3a;
  display: block;
  margin-bottom: 12px;
}
.productAdvantages-box .name {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 22px;
}
.productAdvantages-box .text {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
}
/* 应用场景 */
.businessManagement-top {
  height: 300px;
  background-image: url("~../../assets/YJ-banner.png");
  background-repeat: no-repeat;
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  position: relative;
  text-align: center;
  padding-top: 94px;
  margin-bottom: 110px;
}
.businessManagement-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: 855px;
  top: 87px;
}
.businessManagement-top span {
  display: block;
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 24px;
}
.businessManagement-top p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}
.businessManagement-main {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.businessManagement-mainBox {
  width: 350px;
  height: 190px;
  padding-top: 31px;
  margin-right: 76px;
  margin-bottom: 180px;
  position: relative;
}
.businessManagement-mainBox img {
  display: block;
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
}
.businessManagement-mainBox span {
  display: block;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  margin-bottom: 28px;
}
.businessManagement-mainBox p {
  width: 340px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
}
.businessManagement-number {
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
}
.businessManagement-number img {
  display: block;
  width: 153px;
  height: 190px;
}
/* 特色功能 */
.coreProducts {
  height: 622px;
  background-image: url("~../../assets/coreProducts-banner.png");
  background-repeat: no-repeat;
  position: relative;
  padding-top: 46px;
}
.coreProducts-top {
  text-align: center;
  position: relative;
  margin-bottom: 56px;
}
.coreProducts-top span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.coreProducts-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: 776px;
  top: -14px;
}
.coreProducts-mian {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  position: relative;
}
.coreProducts-mianLeft {
  width: 280px;
  height: 460px;
  padding: 20px 0 54px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.7),
    rgba(255, 255, 255, 0.1)
  );
  z-index: 9;
}
.coreProducts-mianLeftBox {
  width: 280px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  padding: 0 23px 0 49px;
  cursor: pointer;
  align-items: center;
}

.coreProducts-mianLeftBox img {
  display: block;
  width: 16px;
  height: 20px;
  display: none;
}
.coreProducts-mianLeftBox span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #454647;
}
.titleActive {
  z-index: 9;
  background: linear-gradient(90deg, #dc3939, #ff4242);
  box-shadow: 0px 8px 10px 0px rgba(253, 66, 66, 0.2);
  border-radius: 0px 6px 0px 0px;
  align-items: center;
}
.titleActive span {
  color: #ffffff;
}
.titleActive img {
  display: block;
}
.coreProducts-mianRight {
  width: 1060px;
  height: 460px;
  position: relative;
  left: -60px;
  background: #ffffff;
  padding-top: 57px;
  padding-left: 110px;
}
.coreProducts-mianRightBox {
  display: flex;
}
.mianRightBoxLeft-top {
  display: flex;
  flex-direction: column;
  margin-bottom: 76px;
}
.mianRightBoxLeft-top span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 24px;
}
.mianRightBoxLeft-top p {
  width: 393px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
}
.mianRightBoxLeft-bottom > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 33px;
}
.mianRightBoxLeft-bottomBox {
  display: flex;
  flex-wrap: wrap;
}
.mianRightBoxLeft-bottomBoxItem {
  display: flex;
  align-items: center;
  padding-left: 11px;
  margin-bottom: 21px;
  margin-right: 129px;
}
.mianRightBoxLeft-bottomBoxItem:nth-child(2n) {
  margin-right: 0;
}
.mianRightBoxLeft-bottomBoxItem .bottomBoxItem-dain {
  width: 6px;
  height: 6px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  border-radius: 0px 3px 0px 3px;
  margin-right: 11px;
}
.mianRightBoxLeft-bottomBoxItem > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  white-space: nowrap;
}
.coreProducts-mianRightBoxRight {
  display: flex;
  flex-direction: column;
  padding-right: 58px;
  margin-left: 52px;
}
.coreProducts-mianRightBoxRight img {
  display: block;
  width: 446px;
  height: 281px;
  margin-bottom: 44px;
}
.coreProducts-mianRightBoxRight button {
  margin: 0 auto;
  width: 100px;
  height: 34px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  border-radius: 6px 0px 6px 0px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/productIntroduction/ElectronicCommerce.vue